import { FC, useEffect, useState } from "react";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { useMyActions } from "../../../entities/my";
import { MyError } from "../../../shared/lib/error/MyError";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { DropDownListSelected } from "../../../shared/ui/dropDownSelected";
import { IItem } from "../../../shared/model/types";
import classes from './chooseItems.module.scss'

interface IProps {
    title: string;
    selectedItems: number[];
    setItem: (id: number) => void;
    getData: () => Promise<IItem[]>;
    error?: string;
    setError?: (err: string) => void; 
    search?: boolean;
    onSelectItem?: (item: IItem, selected: boolean) => void;
}

export const ChooseItems: FC<IProps> = (
    {selectedItems, setItem, title, getData, error, setError, search, onSelectItem}
) => {

    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsAuth} = useMyActions()
    const [items, setItems] = useState<IItem[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const getDataWrap = async () => {
        try{
            setIsLoading(true)
            const itemsRes = await getData()
            setItems(itemsRes)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: `Ошибка при получении данных`, type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getDataWrap()
    }, [])

    const onSelected = (item: IItem) => {
        return (selected: boolean) => {
            setItem(selected ? item.id : -1) 
            onSelectItem && onSelectItem(item, selected)
            setError && setError('')
        }
    }

    return (
        <section className={classes.container}>
            <section className={classes.title}>{title}</section>
            <DropDownListSelected 
                isLoading={isLoading}
                selectedIdItems={selectedItems}
                items={items}
                onSelected={onSelected}
                search={search}
            />
            <section className={classes.errorText}>
                {error && <>*{error}</>}
            </section>
        </section>
    )
}
